export const STEP_VALIDATION = 'STEP_VALIDATION';
export const STEP_ACCEPTED = 'STEP_ACCEPTED';
export const STEP_REJECTED = 'STEP_REJECTED';
export const STEP_ERROR_LOADING = 'STEP_ERROR_LOADING';
export const SET_STEP = 'SET_STEP';
